import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { ActionItemsGridRowRendererComponent } from 'src/app/components/_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { ApprovalService } from "src/app/_services/approval/approval.service";

@Component({
  selector: 'app-resignation-approval',
  templateUrl: './resignation-approval.component.html',
  styleUrls: ['./resignation-approval.component.scss']
})
export class ResignationApprovalComponent implements OnInit {
  tenantId: string;
  currentUser: any;
  userCreationForm
  defaultColDef:any;
  rowSelection:any
  dataSource: any;
  public columnDefs: ColDef[];
  sampleGridFrameworkComponents: any;
  private api: GridApi;
  private columnApi: ColumnApi;
  selectedRow: any;
  rowData: any;
  isHRAdmin: boolean;

  constructor(
    private storageService: LocalStorageService,
    private router: Router,
    private snackBar: MatSnackBar,
    private approvalService: ApprovalService,
  ) { 
    {
      this.defaultColDef = {
        flex: 1,
        minWidth: 100,
        resizable: true,
      };
      this.rowSelection = 'multiple';
      this.columnDefs = this.createColumnDefs();  

      this.sampleGridFrameworkComponents = {
        actionRowRendererComponent: ActionItemsGridRowRendererComponent
      };
    }
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.getUserSeparation();
  }

  getUserSeparation(){
    this.approvalService.getApprovals('userseparation').subscribe({
      next : (value) => {
        this.rowData = value['userSeparations'];
        console.log('Rowdata', value['userSeperations[]']);
      },
      error(err) {
        this.openSnackBar('ERROR: Getting Resignation' + err)
      },
      complete() {
      }
    });
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space
  onGridReady(params): void {
    this.api = params.api;
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }

  private createColumnDefs() {
    return [
      {
        headerName: 'Employee',
        valueGetter: function(params){
          let user = params.data.userId + " . " + params.data.userName
            return user;
        },
        filter: true,
        editable: false,
        sortable: true,
        cellRenderer: this.createHyperLink.bind(this),
      },
      {
        headerName: 'Employee Id',
        field: 'localId',
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: 'Designation',
        field: 'currentDesignation',
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: 'Requested Date',
        field: 'resignationDate',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Last Working Date',
        field: 'lastWorkingDate',
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: 'Satus',
        field: 'status',
        filter: true,
        editable: false,
        sortable: true,
      },
    ]
  }

  createHyperLink(params): any {
    if (!params.data) { return; }
    const spanElement = document.createElement('span');
    spanElement.innerHTML = `<a href="${params.value}" > ${params.value} </a> `;
    spanElement.addEventListener('click', ($event) => {
      $event.preventDefault();
      this.router.navigate([this.tenantId + '/dashboard/approval/resignation-application-approval'], { queryParams: { resignationId: params.data.id } });
    });
    return spanElement;
  }

  ResignationApprovalApplicationForm(){
    this.router.navigate([ this.tenantId + '/dashboard/approval/resignation-application-approval' ]);
  }

}